import { render, staticRenderFns } from "./BrandPlataform.vue?vue&type=template&id=5669f614"
import script from "./BrandPlataform.vue?vue&type=script&lang=ts"
export * from "./BrandPlataform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports